import { useMemo, useState } from "react";
import { esES, enUS } from "@mui/x-data-grid";
import { MyExportButton } from "../components/partner";
import { useTranslation } from "react-i18next";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { createSheetLP } from "../../helpers/exportToExcel";

export const TableLPWithTotals = ({
  rows,
  columns,
  title,
  name,
  detail,
  generalStartupSheet,
  percentage,
  columnsToExcel,
}) => {
  const { t, i18n } = useTranslation("global");
  const [pageSize, setPageSize] = useState(25);

  const languageTable =
    i18n.language === "en"
      ? enUS.components.MuiDataGrid.defaultProps.localeText
      : esES.components.MuiDataGrid.defaultProps.localeText;

  const data = { rows };

  const rowsData = useMemo(() => {
    if (!data.rows || data.rows.length === 0) {
      return { rows: data.rows };
    }
    const [lastRow, ...rows] = data.rows;
    return {
      rows,
      pinnedRows: {
        bottom: [lastRow],
      },
    };
  }, [data.rows]);

  const startupSheet = createSheetLP(rows, columnsToExcel, percentage);
  const finalSheets = [...generalStartupSheet, ...startupSheet];

  return (
    <>
      <DataGridPro
        autoHeight
        rows={rows}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newPage) => setPageSize(newPage)}
        pagination
        pinnedRows={rowsData.pinnedRows}
        experimentalFeatures={{ rowPinning: true }}
        localeText={{
          ...languageTable,
          toolbarColumns: t("tableButtons.columns"),
          toolbarDensity: t("tableButtons.density"),
          toolbarExport: t("tableButtons.export"),
        }}
        components={{
          Toolbar: MyExportButton,
        }}
        componentsProps={{
          toolbar: {
            page: title,
            name,
            rows,
            dataToExcel: finalSheets,
          },
        }}
        sx={{
          border: "0",
          "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle, .css-cc8tf1": {
            color: "secondary.main", // color diferente en produccion - Comprobar
          },
          "& .MuiDataGrid-cellContent, .css-pdct74-MuiTablePagination-selectLabel, .css-levciy-MuiTablePagination-displayedRows":
            {
              color: "primary.main",
            },
          "& .css-pdct74-MuiTablePagination-selectLabel, .css-levciy-MuiTablePagination-displayedRows":
            {
              color: "secondary.main",
            },
        }}
        getDetailPanelHeight={() => "auto"}
        getDetailPanelContent={({ row }) => detail(row)}
      />
    </>
  );
};
